import ui from 'cy_static/ui'

export default {
  fillZero(num) {
    return num < 10 ? '0' + num : num
  },

  getDateTime(dateString) {
    const date = new Date(dateString)

    return [
      [ date.getFullYear(), this.fillZero(date.getMonth() + 1), this.fillZero(date.getDate()) ].join('-'),
      [ this.fillZero(date.getHours()), this.fillZero(date.getMinutes()), this.fillZero(date.getSeconds()) ].join(':')
    ].join(' ')
  },

  toast(text, duration = 3000, position = 'center') {
    ui.toast({ text, duration, position })
  },

  validURL(url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
  },

  formatePoints(points, unit = '') {
    const res = {}

    if (points < 10000) {
      res.points = parseInt(points)
      res.unit = unit
    } else if (points >= 10000 && points < 100000) {
      res.points = (points / 10000).toString().split('.')

      if (res.points[1]) {
        res.points[1] = res.points[1].slice(0, 2)
      }

      // 避免四舍五入并去末尾 0
      res.points = Number(res.points.join('.'))
      res.unit = '万' + unit
    } else {
      res.points = (points / 10000).toString().split('.')

      if (res.points[1]) {
        res.points[1] = res.points[1].slice(0, 1)
      }

      // 避免四舍五入并去末尾 0
      res.points = Number(res.points.join('.'))
      res.unit = '万' + unit
    }

    return res
  }
}
